import React, { FC, useEffect, useState, forwardRef } from 'react';
import { SelectPicker } from 'rsuite';
import clsx from 'clsx';

const websiteInputSelectorData = [
  {
    value: 'https://',
    label: 'https://',
  },
  {
    value: 'http://',
    label: 'http://',
  },
];

interface Props {
  value: string;
  onChangeCallback: (value: string) => void;
  onBlur?: () => void;
  onPressEnter?: () => void;
  fieldName: string;
  placeholder?: string;
  disabled?: boolean;
  readOnly?: boolean;
}

// eslint-disable-next-line react/display-name
export const WebsiteInput = forwardRef<HTMLInputElement, Props>((props, ref)=> {
  const { value, onChangeCallback, fieldName, placeholder, disabled, readOnly, onBlur, onPressEnter } = props;

  const [protocol, setProtocol] = useState<string>('https://');
  const [url, setUrl] = useState<string>('');

  useEffect(() => {
    if (value?.toLowerCase()?.startsWith('http://')) {
      setProtocol('http://');
      // setUrl(value?.toLowerCase()?.replace('http://', ''));
      setUrl(value?.trim()?.substring(7));
    } else if (value?.toLowerCase()?.startsWith('https://')) {
      setProtocol('https://');
      // setUrl(value?.toLowerCase()?.replace('https://', ''));
      setUrl(value?.trim()?.substring(8));
    } else {
      setUrl(value);
    }
  }, [value]);

  const handleProtocolChange = (selectorValue: string): void => {
    setProtocol(selectorValue);

    const fullValue = url ? selectorValue + url : '';

    onChangeCallback(fullValue);
  };

  const handleUrlChange = (e: React.ChangeEvent<HTMLInputElement>): void => {

    let inputValue = e.target.value;
    let inputProtocol = protocol;

    if (inputValue?.toLowerCase()?.trim()?.startsWith('http://')) {
      // inputValue = inputValue?.toLowerCase().replace('http://', '');
      inputValue = inputValue.trim().substring(7);
      inputProtocol = 'http://';
    } else if (inputValue?.toLowerCase()?.trim()?.startsWith('https://')) {
      // inputValue = inputValue?.toLowerCase().replace('https://', '');
      inputValue = inputValue.trim().substring(8);
      inputProtocol = 'https://';
    } else {
      inputValue = inputValue.trim();
    }

    setUrl(inputValue);
    setProtocol(inputProtocol);

    const fullValue = inputValue ? inputProtocol + inputValue : '';

    onChangeCallback(fullValue);
  };

  return (
    <div className="d-flex align-items-center website-input-container form-control form-control-sm form-control-solid border-0">
      <SelectPicker
        className="p-0 website-select-picker"
        data={websiteInputSelectorData}
        value={protocol}
        onChange={handleProtocolChange}
        // disabled={Boolean(disabled)}
        searchable={false}
        cleanable={false}
      />

      <input
        ref={ref}
        type="text"
        className={clsx('website-input form-control form-control-sm form-control-solid border-0')}
        placeholder={placeholder ? placeholder : ''}
        disabled={Boolean(disabled)}
        readOnly={readOnly}
        id={fieldName}
        value={url ?? ''}
        onChange={handleUrlChange}
        onKeyDown={(e): void => {
          if (e.key === 'Enter') {
            onPressEnter();
          }
        }}
        onBlur={onBlur}
      />
    </div>
  );
});
